import { Component } from '@theme/component';

class KarimHero extends Component {
  #autoplayTimer = null;
  #slidesEl = null;
  #prevBtn = null;
  #nextBtn = null;
  #dots = [];
  #autoplayActive = false;

  #onPrev = () => this.scrollBy(-1);
  #onNext = () => this.scrollBy(1);
  #onSlideChange = () => this.updateDots();

  connectedCallback() {
    super.connectedCallback();
    this.#slidesEl = this.querySelector('[data-slides]');
    if (!this.#slidesEl) return;

    this.#prevBtn = this.querySelector('[data-prev]');
    this.#nextBtn = this.querySelector('[data-next]');
    this.#dots = Array.from(this.querySelectorAll('[data-dot]'));

    this.#prevBtn?.addEventListener('click', this.#onPrev);
    this.#nextBtn?.addEventListener('click', this.#onNext);
    this.#slidesEl.addEventListener('scroll', this.#onSlideChange, { passive: true });

    const autoplay = this.getAttribute('autoplay') === 'true';
    if (autoplay) {
      const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      if (!reduce && !window.matchMedia?.('(max-width: 749px)').matches) {
        this.#startAutoplay();
      }
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    this.#stopAutoplay();
    this.#prevBtn?.removeEventListener('click', this.#onPrev);
    this.#nextBtn?.removeEventListener('click', this.#onNext);
    this.#slidesEl?.removeEventListener('scroll', this.#onSlideChange);
  }

  #startAutoplay() {
    this.#stopAutoplay();
    this.#autoplayActive = true;
    const interval = Math.max(3, parseInt(this.getAttribute('interval') || '5', 10) * 1000);
    this.#autoplayTimer = window.setInterval(() => this.scrollBy(1), interval);
    this.addEventListener('mouseenter', this.#pauseAutoplay, { passive: true });
    this.addEventListener('mouseleave', this.#resumeAutoplay, { passive: true });
  }

  #stopAutoplay() {
    if (this.#autoplayTimer) clearInterval(this.#autoplayTimer);
    this.#autoplayTimer = null;
    this.#autoplayActive = false;
    this.removeEventListener('mouseenter', this.#pauseAutoplay);
    this.removeEventListener('mouseleave', this.#resumeAutoplay);
  }

  #pauseAutoplay = () => { if (this.#autoplayTimer) clearInterval(this.#autoplayTimer); };
  #resumeAutoplay = () => { if (this.#autoplayActive) this.#startAutoplay(); };

  scrollBy(direction) {
    if (!this.#slidesEl) return;
    const slides = Array.from(this.#slidesEl.querySelectorAll('[data-slide]'));
    if (!slides.length) return;
    const currentIdx = this.#currentIndex(slides);
    let nextIdx = currentIdx + direction;
    if (nextIdx >= slides.length) nextIdx = 0;
    if (nextIdx < 0) nextIdx = slides.length - 1;
    const target = slides[nextIdx];
    this.#slidesEl.scrollTo({ left: target.offsetLeft - this.#slidesEl.offsetLeft, behavior: 'smooth' });
  }

  #currentIndex(slides) {
    if (!this.#slidesEl) return 0;
    if (!slides.length) return 0;
    const scrollMid = this.#slidesEl.scrollLeft + this.#slidesEl.clientWidth / 2;
    let best = 0, bestDist = Infinity;
    slides.forEach((s, i) => {
      const c = s.offsetLeft + s.clientWidth / 2 - this.#slidesEl.offsetLeft;
      const d = Math.abs(c - scrollMid);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    return best;
  }

  updateDots() {
    if (!this.#dots.length) return;
    const slides = Array.from(this.#slidesEl.querySelectorAll('[data-slide]'));
    const idx = this.#currentIndex(slides);
    this.#dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === idx);
    });
  }
}

if (!customElements.get('karim-hero')) {
  customElements.define('karim-hero', KarimHero);
}
